export const DIALOG_WIDTH_SMALL = 380;
export const DIALOG_WIDTH_MEDIUM = 480;